"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Customer = void 0;
const _1 = require(".");
class Customer {
    constructor(customer) {
        this._customer = customer;
    }
    toJSON() {
        return (0, _1.removeBlankAttributes)({
            first_name: this._customer.first_name,
            last_name: this._customer.last_name,
            email: this._customer.email,
            phone: this._customer.phone,
            address: this._customer.address,
            city: this._customer.city,
            country: this._customer.country,
            delivery_address: this._customer.delivery_address,
            delivery_city: this._customer.delivery_city,
            delivery_country: this._customer.delivery_country,
        });
    }
}
exports.Customer = Customer;
